<div class="engie-login">
  <div class="engie-accesos">
        <div class="container">
              <div class="row items-accesos">
                <div class="box-login">
                  <h3>PORTAL DE GESTIÓN DE</h3>
                  <h2>TERCEROS</h2>
                </div>
              </div>
        </div>
  </div>

</div>
<div class="engie-form">
  <div class="engie-accesos">
    <div class="row">
      <div class="engie-datos">
        <div class="row">
          <div class="col-md-12">
            <img class="engie-q1" src="./assets/img/Logo_w.svg">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h3 class="engie-q2">Cambiar contraseña</h3>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>NUEVA CONTRASEÑA</mat-label>
              <input matInput [type]="hideNuevaContrasena ? 'password' : 'text'" [(ngModel)]="model.newPassword" />
              <button
                mat-icon-button
                matSuffix
                (click)="hideNuevaContrasena = !hideNuevaContrasena"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideNuevaContrasena"
              >
                <mat-icon>{{ hideNuevaContrasena ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div> 
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>CONFIRMAR CONTRASEÑA</mat-label>
              <input matInput [type]="hideConfirmarContrasena ? 'password' : 'text'" />
              <button
                mat-icon-button
                matSuffix
                (click)="hideConfirmarContrasena = !hideConfirmarContrasena"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirmarContrasena"
              >
                <mat-icon>{{ hideConfirmarContrasena ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div> 

        <div class="row">
          <div class="col-md-12 pad-25">
            <button class="btn btn-azul" type="submit" (click)="submit()" mat-button>Restablecer</button>
            <button class="btn btn-blanco" (click)="cancelar()" mat-button>Cancelar</button>
          </div>           
          
        </div>  
      </div>
    </div>
  </div>

</div>

<!-- <pre>{{model | json}}</pre> -->

